export class Config {

    /**
     *  Допустимые языки
     *  @returns {string[]}
     */
    static get langsAllowed(){ return [ 'en', 'ru' ] }


    /**
     *  Базовый URL
     *  @returns {undefined}
     */
    static get baseUrl(){ return undefined }


    /**
     *  URL к АПИ
     *  @returns {string}
     */
    static get apiUrl(){ return 'https://locode.me/locode/api/new_api.php' }

}